import React from 'react';

const VendorUserSettings = ({ userDetail }) => {
  return (
    <div>
      {/* Tedarikçi kullanıcı ayarları buraya gelecek */}
      <p>Vendor user settings content will be here...</p>
    </div>
  );
};

export default VendorUserSettings;
